import { Box, styled, TableCell, TableRow, ToggleButton } from "@mui/material";

const StyledToggleButton = styled(ToggleButton)({
  textTransform: "capitalize",
  maxHeight: 38,
});

const StyledTableHeader = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#353b48",
  color: theme.palette.common.white,
}));

const StyledTableRow = styled(TableRow)({
  "&:nth-of-type(odd)": {
    backgroundColor: "#f5f6fa",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
});

const StyledMainIssueContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  backgroundColor: '#E3F1FF',
  color: 'white',
  p: 2,
  minHeight: '400px',
  position: 'relative'
})

const StyledTimeLabelContainer = styled(Box)({
  width: '100%',
  height: '40px',
  position: 'relative',
  zIndex: 2,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
})

const StyledTimeContainer = styled(Box)({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#5182b3',
  width: `calc(100% / 24)`,
  boxSizing: 'border-box',
  padding: '0 6px',
  fontSize: 12
})

const StyledTimeLinesContainer = styled(Box)({
  position: 'absolute',
  top: '40px',
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1,
  pointerEvents: 'none'
})

const StyledTimeLine = styled(Box)(({ hour }: { hour: string }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: `${(parseInt(hour, 10) * (100 / 24))}%`,
  width: '1px',
  backgroundColor: '#c7e3ff',
  opacity: 0.9
}))

const StyledRemoveIssue = styled(Box)({
  position: 'absolute',
  top: -8,
  right: 0,
  opacity: 0,
  transition: 'opacity 0.2s',
  cursor: 'pointer',
  backgroundColor: 'white',
  color: 'black',
  borderRadius: '50%',
  width: 20,
  height: 20,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})

interface StyledIssueCardProps {
  left: string
  top: string
  width: string
  backgroundColor: string
  backgroundHover: string
  borderLeftColor: string
}

const StyledIssueCard = styled(Box, { shouldForwardProp: (prop) => prop !== 'backgroundHover' })(
  ({ left, top, width, backgroundColor, backgroundHover, borderLeftColor }: StyledIssueCardProps) => ({
    position: 'absolute',
    color: '#333333',
    left: left,
    top: top,
    width: width,
    display: "flex",
    alignItems: 'center',
    backgroundColor: backgroundColor,
    borderLeft: '3px solid',
    borderColor: borderLeftColor,
    borderRadius: 1,
    padding: "10px",
    mb: '5px', // Add margin bottom
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: backgroundHover,
      transform: 'scale(1.01)',
      zIndex: 1
    },
    '&:hover .close-icon': {
      opacity: 1,
    }
  })
);


export {
  StyledIssueCard,
  StyledMainIssueContainer,
  StyledRemoveIssue,
  StyledTableHeader,
  StyledTableRow,
  StyledTimeContainer,
  StyledTimeLabelContainer,
  StyledTimeLine,
  StyledTimeLinesContainer,
  StyledToggleButton,
};
